import { specialFont, mainFont } from "../../../Infrastructure/Theme/fontFamily";

export const styles = {
  // Hero
  heroSection: {
    background: "linear-gradient(180deg, #f5f7ff 0%, #ffffff 100%)",
    pt: { xs: 8, md: 12 },
    pb: { xs: 8, md: 12 },
  },
  heroEyebrow: {
    fontFamily: mainFont,
    fontWeight: 700,
    fontSize: { xs: "12px", md: "14px" },
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: "#0000FF",
  },
  heroHeadline: {
    fontFamily: specialFont,
    fontSize: { xs: "30px", sm: "38px", md: "48px" },
    lineHeight: 1.25,
    color: "primary.main",
  },
  heroSubtext: {
    fontFamily: mainFont,
    fontSize: { xs: "16px", md: "20px" },
    fontWeight: 400,
    lineHeight: 1.6,
    color: "#555",
    maxWidth: "700px",
  },
  primaryButton: {
    textTransform: "capitalize",
    px: 4,
  },
  secondaryButton: {
    textTransform: "capitalize",
    px: 4,
    backgroundColor: "#fff",
  },

  // Shared section pieces
  section: {
    pt: { xs: 7, md: 10 },
    pb: { xs: 7, md: 10 },
  },
  sectionAlt: {
    pt: { xs: 7, md: 10 },
    pb: { xs: 7, md: 10 },
    backgroundColor: "#f5f7fa",
  },
  sectionTitle: {
    fontFamily: specialFont,
    fontSize: { xs: "24px", md: "32px" },
    color: "primary.main",
    textAlign: "center",
    lineHeight: 1.3,
  },
  sectionSubtitle: {
    fontFamily: mainFont,
    fontSize: { xs: "16px", md: "18px" },
    color: "#555",
    textAlign: "center",
    maxWidth: "640px",
    mx: "auto",
    mt: 2,
    lineHeight: 1.6,
  },

  // Features
  featureCard: {
    height: "100%",
    backgroundColor: "#fff",
    border: "1px solid #eee",
    borderRadius: "20px",
    p: 3,
  },
  featureIconCircle: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: "primary.main",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 2,
  },
  featureTitle: {
    fontFamily: mainFont,
    fontWeight: 700,
    fontSize: "18px",
    color: "#1c1d1f",
    mb: 1,
  },
  featureDescription: {
    fontFamily: mainFont,
    fontSize: "15px",
    color: "#555",
    lineHeight: 1.6,
  },

  // How it works
  stepNumberCircle: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    backgroundColor: "primary.main",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: specialFont,
    fontSize: "24px",
    mx: "auto",
    mb: 2,
  },
  stepTitle: {
    fontFamily: mainFont,
    fontWeight: 700,
    fontSize: "20px",
    color: "#1c1d1f",
    textAlign: "center",
    mb: 1,
  },
  stepDescription: {
    fontFamily: mainFont,
    fontSize: "16px",
    color: "#555",
    textAlign: "center",
    lineHeight: 1.6,
    maxWidth: "320px",
    mx: "auto",
  },

  // Audience
  audienceCard: {
    height: "100%",
    backgroundColor: "#fff",
    border: "1px solid #eee",
    borderRadius: "20px",
    p: { xs: 3, md: 4 },
  },
  audienceTitle: {
    fontFamily: mainFont,
    fontWeight: 700,
    fontSize: "20px",
    color: "primary.main",
    mb: 2,
  },
  audienceBullet: {
    fontFamily: mainFont,
    fontSize: "15px",
    color: "#555",
    lineHeight: 1.6,
  },
};
